if (!Blob.prototype.stream) {
  Blob.prototype.stream = function () {
    const blob = this;
    return {
      getReader() {
        return {
          read() {
            return new Promise<{ value: Uint8Array, done: boolean }>((resolve) => {
              const fileReader = new FileReader();
              fileReader.addEventListener('loadend', () => {
                resolve({
                  value: new Uint8Array(fileReader.result as ArrayBuffer),
                  done: true,
                });
              });
              fileReader.readAsArrayBuffer(blob);
            });
          },
        };
      },
    } as any;
  };
}